import * as ChapterType from "utils/ChapterType";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import { createSelector } from "reselect";
import includes from "lodash/includes";

export default function makeGetShowCuepoints() {
  return createSelector([getChapterEntity], (chapterEntity) => {
    if (!chapterEntity) {
      return false;
    }

    return includes(
      [ChapterType.VIDEO, ChapterType.SLIDESHOW],
      chapterEntity.type,
    );
  });
}
